import { create } from "zustand";



import { wowPartnerApi } from "../apis";
import { PartnerStock } from "../apis/wowPartner";


// 매매 전략 리스트 담는 store
const usePartnerStore = create<PartnerStockStore>((set) => ({
  partnerStockList: {
    isView: "N",
    itemCount: 0,
    boardUrl: "",
    baseDatetime: "",
    stockItemList: [],
  },
  setPartnerStockList: (partnerList: PartnerStock) => set(() => ({
    partnerStockList: { ...partnerList },
  })),
}));
interface PartnerStockStore {
  partnerStockList: PartnerStock
  setPartnerStockList: (partnerList: PartnerStock) => void
}

// 매매 전략 리스트 중 -> 종목명 클릭시 사용
const usePartnerStockItemSeq = create((set) => ({
  itemSeq: null,
  setItemSeq: (itemSeq: string) => set({ itemSeq }),
}))

// 매매 전략 리스트 중 -> 종목명 우측 아이콘 클릭시 사용
const usePartenerTradeStrategy = create((set) => ({
  isOpenTradeStrategy: false,
  strategyItemSeq: null,
  setIsOpenTradeStrategy: (isOpenTradeStrategy: boolean) =>
    set({ isOpenTradeStrategy }),
  setStrategyItemSeq: (strategyItemSeq: string) => set({ strategyItemSeq }),

  // 위에 2가지 동시에 하는 기능 (setIsOpenTradeStrategy, setStrategyItemSeq)
  setTradeStrategy: (isOpenTradeStrategy: boolean, strategyItemSeq: string) =>
    set({
      isOpenTradeStrategy,
      strategyItemSeq,
    }),
}))

export { usePartnerStockItemSeq, usePartenerTradeStrategy, usePartnerStore }

